import _extends from "@babel/runtime/helpers/esm/extends";
import { GridSearchIcon, GridClearIcon, GridAddIcon, GridCheckIcon, GridExpandMoreIcon, GridDeleteIcon, GridCloseIcon } from '@mui/x-data-grid';
import { GridArrowDownwardIcon, GridArrowUpwardIcon, GridFilterAltIcon } from '@mui/x-data-grid-pro';
import { GridWorkspacesIcon, GridGroupWorkIcon, GridFunctionsIcon, GridMoveToTopIcon, GridMoveToBottomIcon, GridExpandLessIcon, GridPivotIcon, GridSendIcon, GridMicIcon, GridMicOffIcon, GridAssistantIcon, GridPromptIcon, GridRerunIcon, GridHistoryIcon, GridChartsIcon, GridSyncDisabledIcon, GridSyncIcon } from "./icons.mjs";
const iconsSlots = {
  collapsibleIcon: GridExpandMoreIcon,
  columnMenuUngroupIcon: GridWorkspacesIcon,
  columnMenuGroupIcon: GridGroupWorkIcon,
  columnMenuAggregationIcon: GridFunctionsIcon,
  pivotIcon: GridPivotIcon,
  pivotSearchIcon: GridSearchIcon,
  pivotSearchClearIcon: GridClearIcon,
  pivotMenuAddIcon: GridAddIcon,
  pivotMenuMoveUpIcon: GridExpandLessIcon,
  pivotMenuMoveDownIcon: GridExpandMoreIcon,
  pivotMenuMoveToTopIcon: GridMoveToTopIcon,
  pivotMenuMoveToBottomIcon: GridMoveToBottomIcon,
  pivotMenuCheckIcon: GridCheckIcon,
  pivotMenuRemoveIcon: GridDeleteIcon,
  sidebarCloseIcon: GridCloseIcon,
  aiAssistantIcon: GridAssistantIcon,
  aiAssistantPanelCloseIcon: GridCloseIcon,
  aiAssistantPanelNewConversationIcon: GridAddIcon,
  aiAssistantPanelHistoryIcon: GridHistoryIcon,
  promptIcon: GridPromptIcon,
  promptSendIcon: GridSendIcon,
  promptSpeechRecognitionIcon: GridMicIcon,
  promptSpeechRecognitionOffIcon: GridMicOffIcon,
  promptRerunIcon: GridRerunIcon,
  promptSortAscIcon: GridArrowUpwardIcon,
  promptSortDescIcon: GridArrowDownwardIcon,
  promptFilterIcon: GridFilterAltIcon,
  promptPivotIcon: GridPivotIcon,
  promptAggregationIcon: GridFunctionsIcon,
  promptGroupIcon: GridGroupWorkIcon,
  promptChartsIcon: GridChartsIcon,
  promptChangesToggleIcon: GridExpandMoreIcon,
  chartsIcon: GridChartsIcon,
  chartsSearchIcon: GridSearchIcon,
  chartsSearchClearIcon: GridClearIcon,
  chartsMenuMoveUpIcon: GridExpandLessIcon,
  chartsMenuMoveDownIcon: GridExpandMoreIcon,
  chartsMenuMoveToTopIcon: GridMoveToTopIcon,
  chartsMenuMoveToBottomIcon: GridMoveToBottomIcon,
  chartsMenuAddIcon: GridAddIcon,
  chartsMenuRemoveIcon: GridDeleteIcon,
  chartsSyncIcon: GridSyncIcon,
  chartsSyncDisabledIcon: GridSyncDisabledIcon
};
const materialSlots = _extends({}, iconsSlots);
export default materialSlots;